import { Helmet } from 'react-helmet';

export function FontLinks() {
  return (
    <Helmet>
      <link
        as="font"
        crossOrigin="anonymous"
        href="/fonts/formula/PP-Formula-SemiExtendedBold.woff2"
        rel="preload"
        type="font/woff2"
      />
      <link
        as="font"
        crossOrigin="anonymous"
        href="/fonts/cinetype/GT-Cinetype-Light.woff2"
        rel="preload"
        type="font/woff2"
      />
      <link
        href="/styles/brand-refresh-fonts.css"
        rel="stylesheet"
        type="text/css"
      />
      <link
        href="https://fonts.googleapis.com/css?family=IBM+Plex+Sans:300,400,500,600,700|IBM+Plex+Mono:400,500,700|IBM+Plex+Serif:300,400,500,600,700&amp;display=swap"
        media="print"
        // @ts-expect-error this is a valid link attribute
        onload="this.media='all'"
        rel="stylesheet"
      />
    </Helmet>
  );
}
